import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCommentDots } from '@fortawesome/free-solid-svg-icons'
import MessageDisplayCard from './message-display-card'
import ChaseListItem from './chase-list-item'
import CustomButton from './custom-button'
import UseChaseProvider from '../utils/use-chase-provider'

const doneStatus = ["Pending-Review", "Approved"]

const getInitials = (name?: string) => (name || "").trim().split(/\s+/).map((part) => part[0]).slice(0, 2).join("").toUpperCase()

const ChaseDisplayCard: React.FC = () => {
    const { chase, ToggleMessage } = UseChaseProvider()
    const allItems = [...(chase?.chaseItem || []), ...(chase?.drivers?.flatMap((driver) => driver?.chaseItem || []) || [])]
    const doneCount = allItems.filter((item) => doneStatus.includes(item?.status)).length
    const donePercent = allItems.length ? Math.round((doneCount / allItems.length) * 100) : 0

    return (
        <div className="w-full max-w-[520px] surface-card px-4 py-6 sm:px-8 sm:py-8 animate-drop-in">

            {/* --------------------- [ DISPLAY CARD HEADER ] -------------------------- */}

            <div className='text-center'>
                <h2 className="text-hero sm:text-heroXL inline-flex items-center justify-center gap-3 flex-wrap">
                    <span className="inline-block text-[30px] sm:text-[34px] leading-none origin-[70%_75%] animate-wave" aria-hidden>👋</span>
                    <span className="text-white">Hey <span className="capitalize bg-[linear-gradient(90deg,#5E9CFF,#A855F7_55%,#F0789A)] bg-clip-text text-transparent">{chase?.firstName}</span></span>
                </h2>
            </div>

            {/* --------------------- [ DISPLAY CARD HEADER ] -------------------------- */}


            {/* --------------------- [ DISPLAY MESSAGE CARD ] -------------------------- */}
            <div className="mt-[55px]">

                <MessageDisplayCard />
            </div>
            {/* --------------------- [ DISPLAY MESSAGE CARD ] -------------------------- */}


            {/* --------------------- [ DOCUMENTS PROGRESS ] -------------------------- */}

            {allItems.length > 0 && <div className='mt-8'>
                <div className='flex items-baseline justify-between'>
                    <h3 className='text-titleSM text-white'>Your documents</h3>
                    <p className='text-pill uppercase text-white/[0.66] tabular-nums'>{doneCount} of {allItems.length} done</p>
                </div>
                <div className='mt-3 h-1.5 w-full rounded-full bg-white/[0.10] overflow-hidden' role='progressbar' aria-valuenow={donePercent} aria-valuemin={0} aria-valuemax={100} aria-label='Documents done'>
                    <div className='h-full rounded-full bg-success transition-[width] duration-700 ease-out-cubic' style={{ width: `${donePercent}%` }} />
                </div>
            </div>}

            {/* --------------------- [ DOCUMENTS PROGRESS ] -------------------------- */}


            {/* --------------------- [ CHASE ITEMS ] -------------------------- */}

            <div className='mt-4 flex flex-col gap-2'>
                {chase?.chaseItem?.map((item, index) => {
                    return (
                        <div key={item.type} className='animate-drop-in' style={{ animationDelay: `${140 + index * 140}ms` }}>
                            <ChaseListItem item={item} />
                        </div>
                    )
                })}

            </div>

            {/* --------------------- [ CHASE ITEMS ] -------------------------- */}


            {/* ------------------------------ [ DRIVERS ITEM ] --------------------- */}

            {chase?.drivers?.map((driver) => {
                return (
                    <section className='mt-6 pt-6 border-t border-white/[0.08] animate-drop-in' key={driver.id}>
                        <div className='flex items-center gap-3 pb-2'>
                            <span className='min-w-[36px] h-[36px] rounded-full bg-tile ring-1 ring-inset ring-white/[0.10] flex items-center justify-center text-[12.5px] font-extrabold tracking-wide text-white/90' aria-hidden>{getInitials(driver.name)}</span>
                            <div className='min-w-0'>
                                <p className='text-pill uppercase text-white/[0.55]'>Additional Driver</p>
                                <h2 className='text-titleSM mt-1 text-white capitalize truncate'>{driver.name}</h2>
                            </div>
                        </div>

                        <div className='mt-2 flex flex-col gap-2'>
                            {driver?.chaseItem?.map((item, index) => {
                                return (
                                    <ChaseListItem key={item.type + index} item={item} driverId={driver?.id} />
                                )
                            })}

                        </div>
                    </section>
                )
            })}

            {/* ------------------------------ [ DRIVERS ITEM ] --------------------- */}


            {/* --------------------- [ CHASE CAT ] -------------------------- */}

            <div className='mt-8 pt-6 border-t border-white/[0.12]'>
                <p className='font-medium text-white/[0.66] text-[14px] text-center mb-3'>Need Help?</p>
                <CustomButton onClick={ToggleMessage}>
                    <FontAwesomeIcon icon={faCommentDots} className='text-[16px]' /> Reply to message
                </CustomButton>
            </div>
            {/* --------------------- [ CHASE CAT ] -------------------------- */}

        </div>
    )
}

export default ChaseDisplayCard
